import { defineMessages } from 'react-intl';

export const NUMBER_WITH_UNIT_VALIDATION_MESSAGES = defineMessages({
  incomplete: { id: 'app.common.form.validation.numberWithUnitIncomplete' },
});
